import React from 'react'
import { Box, Typography, SxProps, Theme } from '@mui/material'
import RequiredBadge from './RequiredBadge'

/**
 * 必須項目のフィールド外ラベル（ラベルテキスト＋必須バッジ）
 *
 * フォームUX_バリデーション共通設計方針 §3 に準拠。
 * MUI のフローティングラベル内に「＊」を出す代わりに、フィールド上部へ
 * ラベルテキストと薄紅枠「必須」バッジを横並びで表示するための共通部品。
 */
interface RequiredFieldLabelProps {
  label: string
  badgeLabel?: string
  sx?: SxProps<Theme>
}

const RequiredFieldLabel: React.FC<RequiredFieldLabelProps> = ({ label, badgeLabel, sx }) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5, ...sx }}>
      <Typography variant="body2" sx={{ fontWeight: 500 }}>
        {label}
      </Typography>
      <RequiredBadge label={badgeLabel} />
    </Box>
  )
}

export default RequiredFieldLabel
